'use strict';
import { Sortable, Draggable, Droppable, Plugins } from '@shopify/draggable/lib/es5/draggable.bundle';

export function FieldPreset(){
  const containers = document.querySelectorAll('.draggable');

  const droppable = new Droppable(containers, {
    draggable: '.presetHandle',
    dropzone: '.dropzone',
    mirror: {
      constrainDimensions: true,
    }
  });

  let target;
  droppable.on('droppable:dropped', (evt) =>{
    evt.cancel();
    target = evt.dropzone;
  });

  droppable.on('droppable:stop', (evt) =>{
    droppable.source.classList.add('adding-preset');
    target.classList.add('drop-target');
    if(target.classList.contains("sortable")){
      $(".editField a.add_field_box_append").trigger('click');
    }
    if(target.classList.contains("field_box")){
      $(".editField a.add_field_box_before").trigger('click');
    }
    target.classList.remove('drop-target');
  });

  return droppable;
}

export function FieldsList(){
  const containerSelector = '.sortable';
  const containers = document.querySelectorAll(containerSelector);

  if (containers.length === 0) {
    return false;
  }

  const sortable = new Sortable(containers, {
    draggable: '.field_box',
    appendTo: containerSelector,
    mirror: {
      constrainDimensions: true,
    },
    swapAnimation: {
      duratiuon: 200,
      easingFunction: 'ease-in-out'
    },
    plugins: [Plugins.SwapAnimation]
  });

  sortable.on('drag:start',(evt)=>{
    if(!document.querySelector('.dialogue-shadow').classList.contains("hidden")){
      evt.cancel();
    }
    if(evt.originalEvent.target.tagName === ("A") || evt.originalEvent.target.parentNode.tagName === ("A")){
      evt.cancel();
    }
  });

  return sortable;
}

export function InsertField(){
  $('.sortable').on('cocoon:after-insert', function(e, insertedItem){
    if(!insertedItem.hasClass('field_box'))return;

    const source = document.querySelector('.adding-preset');
    const presetJSON = JSON.parse(source.dataset.preset);

    insertedItem.find('input[name$="[name]"]').first().val(presetJSON['name']);
    insertedItem.find('.field_information .name').text(presetJSON['name']);
    presetJSON["field_inputs"].forEach(function(v){
      insertedItem.find('[data-association="field_input"]').trigger('click');
      insertedItem.find('.field_inputs .field_input').last().find('input[name$="[name]"]').val(v['name']);
      insertedItem.find('.field_inputs .field_input').last().find('input[name$="[input_type]"]').val(v['input_type']);
      insertedItem.find('.field_inputs .field_input').last().find('input[name$="[is_used_for_receipt]"]').prop('checked', v['is_used_for_receipt']);
      insertedItem.find('.field_inputs .field_input').last().find('input[name$="[is_used_for_name_plate]"]').prop('checked', v['is_used_for_name_plate']);
      v['field_input_options'].forEach(function(o){
        insertedItem.find('.field_inputs .field_input').last().find('[data-association="field_input_option"]').trigger('click');
        insertedItem.find('.field_inputs .field_input').last().find('.field_input_options input[type="text"]').last().val(o['name']);
      });
      if(v['input_type']!="radio_buttons" && v['input_type']!="select" && v['input_type']!="check_boxes"){
        insertedItem.find('.field_inputs .field_input').last().find(".field_input_options").remove();
      }
    });
    $.ajax({url:source.dataset.sample, type:'GET'}).done((data)=>{
        insertedItem.find('.sample').prepend(data);
    });
    source.classList.remove('adding-preset');
  });
}



// WEBPACK FOOTER //
// ./app/javascript/packs/edit_field.js